export default __webpack_public_path__ + "static/048-65d95263975f67288de5ffbef49206a3.jpg";